export default __webpack_public_path__ + "assets/images/b1e6eec827b98493193dda23a5988685.svg";